import LoginViewModelT from '@/ViewModels/Views/LoginViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
export default class LoginViewFactory extends ViewFactory {
    public viewModel: any;
    public view: any;
    private LoginViewModel: any;
    private LoginView: any;
    constructor(params: any) {
        super(params);
        this.LoginViewModel = ComponentManager.getViewModel<typeof LoginViewModelT>('LoginViewModel');
        this.LoginView = ComponentManager.getView('LoginView');
    }
    public getRegion(): string {
        return 'Body';
    }
    public getView(): any {
        if (this.viewModel == null) {
            this.viewModel = new this.LoginViewModel({
                locator: 'login',
                viewFactory: this
            });
        }
        if (this.view == null) {
            this.view = new this.LoginView(this.viewModel, this.createRootElement('Login'));
        }
        this.setPageTitle('Login');
        let tuple = this.view.getTuple();
        return tuple.view;
    }
    public getNecessaryRedirect(): any {
        return false;
    }
}

ComponentManager.setFactory('Login', LoginViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');